import { Box, Paper, Typography } from '@mui/material';
import { useDraggable } from '@dnd-kit/core';
import { schemaCardStyles } from '../styles/schemaCardStyles';
import { eventCardStyles } from '../styles/eventCardStyles';

export default function SchemaCard({ schema, isDragOverlay = false }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `schema-${schema.id}`,
    data: { type: 'schema', schema },
  });

  const attrCount = schema.values?.length || 0;

  return (
    <Paper
      ref={isDragOverlay ? undefined : setNodeRef}
      elevation={0}
      sx={{ ...schemaCardStyles.card(isDragOverlay), opacity: isDragging ? 0.4 : 1 }}
      {...(isDragOverlay ? {} : listeners)}
      {...(isDragOverlay ? {} : attributes)}
    >
      <Typography sx={schemaCardStyles.title} noWrap title={schema.event_title}>
        {schema.event_title}
      </Typography>
      <Box sx={schemaCardStyles.metaRow}>
        {schema.event_type && (
          <Typography sx={schemaCardStyles.type}>{schema.event_type}</Typography>
        )}
        {schema.priority && (
          <Box sx={eventCardStyles.priorityBadge(schema.priority)}>{schema.priority}</Box>
        )}
        <Typography sx={schemaCardStyles.attrCount}>{attrCount} attribute(s)</Typography>
      </Box>
    </Paper>
  );
}
